module.exports = __webpack_public_path__ + "static/media/who-10.d52bd72b.jpg";